import { Hierarchy, Rank } from 'iconsax-react'
import { useTheme } from '@mui/material'

import Tooltip from '../../../../components/atoms/Tooltip'
import EventIconMap from './EventIconMap'

import useStyles from './styles'

const getEventIcon = (event, theme) => {
  if (event.type === 'reminder' && event.objectType)
    return <EventIconMap theme={theme} objectType={event.objectType} />

  if (event.isSubtask) return <Hierarchy size={theme.size.base} />
  if (event.isParent) return <Rank size={theme.size.base} />
  return null
}

const Event = ({ event }) => {
  const theme = useTheme()
  const classes = useStyles()
  const Icon = getEventIcon(event, theme)

  return (
    <Tooltip
      title={`${
        event.isSubtask ? 'Subtask: ' : event.isParent ? 'Parent task: ' : ''
      } ${event.longTitle}`}
      arrow
    >
      <label className={classes.root}>
        {Icon}
        {event.longTitle}
      </label>
    </Tooltip>
  )
}

export default Event
